/* eslint-disable react/jsx-no-literals */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import actions from '../../actions/actions';
import {Button} from '@homeaway/react-buttons';
import './BookWidget.less';
import {TrackingContext} from '@homeaway/react-event-tracking';

function mapStateToProps(state) {
    // Each container component will likely only pull in the state that
    // it cares about. Doing so will eliminate unnecessary rerenders.
    return state;
}

function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators(actions, dispatch), dispatch};
}

@connect(mapStateToProps, mapDispatchToProps)
class BookWidget extends Component {
    static contextType = TrackingContext;

    constructor(props) {
        super(props);
    }

    eventButtonClick = () => {
        this.context.trigger('generic.click', {
            eventaction: 'check availability click'
        });
    };

    eventLogoClick = () => {
        this.context.trigger('generic.click', {
            eventaction: 'logo click'
        });
    };

    getHostByEnv() {
        let host = '';

        if (this.props.system.environment === 'development' || this.props.system.environment === 'test') {
            host = this.props.system.hostnameByEnvironment.TEST;
        }

        if (this.props.system.environment === 'stage') {
            host = this.props.system.hostnameByEnvironment.STAGE;
        }

        if (this.props.system.environment === 'production') {
            host = this.props.system.hostnameByEnvironment.PRODUCTION;
        }

        return host;
    }

    generateTravelerLinkWithUnitId(propertyId, unitId) {
        let path = '';

        path = this.props.system.listingUrlTemplateWithUnit
            .replace('%s', '')
            .replace('%s', propertyId)
            .replace('%s', unitId);

        return `http://${this.getHostByEnv()}${path}`;
    }

    generateTravelerLink(propertyId) {
        let path = '';

        path = this.props.system.listingUrlTemplate
            .replace('%s', '')
            .replace('%s', propertyId);

        return `http://${this.getHostByEnv()}${path}`;
    }

    generateLogoLink() {
        return `//csvcus.homeaway.com/rsrcs/cdn-logos/3.1.0/northstar/moniker/${this.props.system.siteName}/logo.svg`;
    }

    render() {
        const {propertyId, unitId} = this.props.property;
        let travelerLink = unitId !== '' ? this.generateTravelerLinkWithUnitId(propertyId, unitId) : this.generateTravelerLink(propertyId);
        let widgetClass = `widget-content ${this.props.system.siteName}`;
        return (
            <div className={widgetClass}>
                <h3>{this.props.translations['haow.book.property']}</h3>
                <Button href={travelerLink} onClick={this.eventButtonClick} className="btn-sm btn-primary widget-button" target="_blank" rel="nofollow"
                    label={this.props.translations['haow.bookit.inner.button']}
                />
                <div className="widget-footer">
                    <a href={travelerLink} onClick={this.eventLogoClick} target="_blank" rel="nofollow">
                        <img src={this.generateLogoLink()} className="logo"/>
                    </a>
                </div>
            </div>
        );
    }
}

export default BookWidget;
